import { FetchError } from 'ofetch'
import { PASSWORD_REQUIRED_HEADER_MSG } from './deck-password'

export function isFetchErrorStatus(error: unknown, statusCode: number): error is FetchError {
  return error instanceof FetchError && error.response?.status === statusCode
}

export class AuthError extends FetchError {
  constructor(message: string) {
    super(message)
    this.name = 'AuthError'
    this.status = 401
    this.statusCode = 401
  }
}

export class PasswordRequiredError extends FetchError {
  constructor(message: string) {
    super(message)
    this.name = 'PasswordRequiredError'
    this.status = 401
    this.statusCode = 401
  }
}

export class PermissionsError extends FetchError {
  constructor(message: string) {
    super(message)
    this.name = 'PermissionsError'
    this.status = 401
    this.statusCode = 401
  }
}

export class ExpiredError extends FetchError {
  constructor(message: string) {
    super(message)
    this.name = 'ExpiredError'
    this.status = 410
    this.statusCode = 410
  }
}

export class DeckNotFoundError extends FetchError {
  constructor(message: string) {
    super(message)
    this.name = 'DeckNotFoundError'
    this.status = 404
    this.statusCode = 404
  }
}

export class LegacyDeckError extends Error {
  constructor(message: string = 'This 3D Presentation contains legacy 3D model slides that are no longer supported.') {
    super(message)
    this.name = 'LegacyDeckError'
  }
}

export function normalizeDeckFetchError(error: unknown, isAuthenticated: boolean): unknown {
  if (!(error instanceof FetchError)) return error
  const { message } = error

  if (isFetchErrorStatus(error, 401) && error.response?.headers.get('www-authenticate') === PASSWORD_REQUIRED_HEADER_MSG) {
    return new PasswordRequiredError(message)
  }

  if (isFetchErrorStatus(error, 403)) {
    return new PermissionsError(message)
  }

  if (isFetchErrorStatus(error, 404)) {
    return new DeckNotFoundError(message)
  }

  if (isFetchErrorStatus(error, 410)) {
    return new ExpiredError(message)
  }

  if (!isAuthenticated) {
    return new AuthError(message)
  }

  return error
}
